<template>
    <div class="alter" v-show="show">
        <div :class="'box_alter center '+(size[type]||size['def'])">
            <div class="img_38 close" @click="close" v-show='!is_show_close'></div>
            <component v-if="show" :is="type" :data="data" @close="close" @show_box="show_box" @show_close="show_close"></component>
        </div>


    </div>
</template>

<script>
var rule = require('./all_alter/rule.vue')
var lottery_log = require('./all_alter/lottery_log.vue')
var probability = require('./all_alter/probability.vue')
var login = require('./all_alter/login.vue')
var show_probability = require('./all_alter/show_probability.vue')
var err = require('./all_alter/err.vue')
var determine_config = require('./all_alter/determine_config.vue')
var knapsack = require('./all_alter/knapsack.vue')
var shave_page = require('./all_alter/shave_page.vue')
var weixin = require('./all_alter/weixin.vue')
var lottery = require('./all_alter/lottery.vue')

module.exports = {
    components: {
        rule,
        lottery_log,
        probability,
        login,
        err,
        show_probability,
        determine_config,
        knapsack,
        shave_page,
        weixin,
        lottery,
        // alter,
    },
    data() {
        return {
            show: false,
            // 传递
            type         : null,
            data         : null,
            is_show_close: false,
            size         : {
                rule            : 'img_65',
                show_probability: 'img_35',
                // show_probability: 'img_62',
                lottery_log     : 'img_62',
                knapsack        : 'img_35',
                shave_page      : 'img_null_40',
                lottery         : 'all_bg',
                def             : 'img_58',
            }
        }
    },
    created() {
        this.size.shave_page = this.is_pc() ? 'img_null_40_pc' : 'img_null_40_h5'

    },
    methods: {
        is_pc() {
            return !window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
        },
        log() {
        },
        show_close(is_show_close){
            console.log('is_show_close',this.is_show_close)
            this.is_show_close = !!is_show_close
        },
        show_box(type, data, callback, option) {
            this.show = true
            this.type = type
            this.data = data
            this.callback = callback
            option = option || {}
            this.is_show_close = !!option.is_show_close
            console.log('is_show_close',this.is_show_close, option)
            // console.log('show_box', type, data, callback)
        },
        close(data) {
            this.show = false
            this.callback && this.callback(data)
        }
    }
}
</script>

<style scoped>
.alter {
    position: fixed;
    top: 0rem;
    left: 0rem;
    width: 100%;
    height: 100%;
    background: #000000aa;
    z-index: 100;
}

.center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.close {
    cursor: pointer;
    position: absolute;
    right: -0.1rem;
    top: -0.1rem;
    z-index: 22;
}

.alter >>> .big_box {
    width: 5.996rem;
    height: 95.5%;
    position: absolute;
    left: 0.12rem;
    top: 0.32rem;
    overflow-y: auto;
}

.alter >>> .title_center {
    margin: .2rem auto;
}

.alter >>> .content_center {
    margin: .4rem auto;
}

.alter >>> .button {
    margin: .4rem auto;
    width: 100%;
    text-align: center;
}

.alter >>> .button div {
    display: inline-block;
    margin: 0rem .5rem;
}
</style>